<template>
  <div class="modal-card "
      style="width: auto; min-width: 320px;">
    <header class="modal-card-head">
      <p class="modal-card-title">{{ $t('index.profile.change_password') }}</p>
    </header>
    <section class="modal-card-body">

      <b-field :label="$t('index.profile.current_password')"
          v-bind:type="{'is-danger': data.messages.pass }"
          :message="{ [$t(`index.profile.errors.${this.data.messages.pass}`)]: data.messages.pass }">
          <b-input type="password"
              v-model="form.pass">
          </b-input>
      </b-field>

      <b-field :label="$t('index.profile.new_password')"
          v-bind:type="{'is-danger': data.messages.newpass }"
          :message="{ [$t(`index.profile.errors.${this.data.messages.newpass}`)]: data.messages.newpass }">
          <b-input type="password"
              v-model="form.newpass">
          </b-input>
      </b-field>

      <b-field :label="$t('index.profile.confirm_password')"
          v-bind:type="{'is-danger': data.messages.confirmpass }"
          :message="{ [$t(`index.profile.errors.${this.data.messages.confirmpass}`)]: data.messages.confirmpass }">
          <b-input type="password"
              v-model="form.confirmpass">
          </b-input>
      </b-field>

    </section>

    <footer class="modal-card-foot columns is-gapless">

      <div class="column is-half">
        <button
          class="button"
          type="button"
          @click="$parent.close()"
        >{{$t('index.close')}}</button>
      </div>

      <div class="column is-half has-text-right">
        <button
          class="button is-info"
          @click="saveData"
        >{{$t('index.save')}}</button>
      </div>
    </footer>
  </div>
</template>

<script>
// import FDateTime from './FDateTime.vue';
import Vue from 'vue';
import Notification from 'vue-bulma-notification';
const NotificationComponent = Vue.extend(Notification);
const openNotification = (
  propsData = {
    title: '',
    message: '',
    type: '',
    direction: '',
    duration: 4500,
    container: '.notifications'
  }
) => {
  return new NotificationComponent({
    el: document.createElement('div'),
    propsData
  });
};

export default {
  // props: ['roomData'],
  components: {
    Notification,
  },
  data() {
    return {
      data: {
        messages: {
          pass: '',
          newpass: '',
          confirmpass: ''
        }
      },
      initResponse: {},
      param: {},
      isloading: false,
      form: {
        uid: 1662,
        uuid: 'b6111f61-6051-4c28-8420-bea7947a2774',
        pass: null,
        newpass: null,
        confirmpass: null,
      },


    };
  },
  methods: {
    openNotificationWithType(type, title, message) {
      openNotification({
        title: title,
        message: message,
        type: type
      });
    },
    saveData () {
      this.isloading = true
      // this.data.length = 0
      this.$http({
        method: 'post',
        url:`https://iridi.com/customer/api_byod/?act=change_password`,
        data:this.form
      }).then((response) => {
        this.changed = false;
        this.data = response.data
        this.isloading = false
        if (response.data.status === 'success') {
          this.openNotificationWithType('success', '', this.$t('index.profile.password_reset_success'))
          this.$parent.close()
        }
      }).catch((error) => {
        console.log(error)
        this.isloading = false
        this.changed = false;
      })
    },

    loadData(objectId) {
      console.log('loadData', objectId);
      this.isloading = true;
      this.data.length = 0;
      this.$http({
        method: 'post',
        url: `${this.$backendHost}/frontend/api/init/admin`,
        transformResponse: [
          data => {
            return JSON.parse(data);
          }
        ],
        data: {
          objectId: objectId
        }
      })
        .then(response => {
          if (response.data.error) {
            console.log('ERRORWS');
            this.openNotificationWithType('danger', '', response.data.error);
          } else {
            response.data.objects.map(o => {
              o.defArrivalTime = new Date(o.defArrivalTime);
              o.defDepartureTime = new Date(o.defDepartureTime);
              console.log(o);
              return o;
            });
            this.$set(this, 'initResponse', response.data);
          }
          this.isloading = false;
        })
        .catch(error => {
          this.isloading = false;
          this.openNotificationWithType('danger', '', error.error || error);
        });
    }

  },
  computed: {},
  mounted() {
    // this.loadData();
  }
};
</script>




// WEBPACK FOOTER //
// Changepassword.vue?0b537caa